import { useEffect, useState } from "react";
import {
  ModificationType,
  ProcedureDetailType,
} from "@graffer-inc/cloud-gov-core";
import {
  ModifyFormGeneratorProps,
  ModifyFormViewModel,
} from "../../../../application/domain/form-model/modify-form-view-model";
import { ApplicationEntity } from "../../../../application/domain/application/application-entity";

export const useModifyForm = (args: {
  procedure: ProcedureDetailType;
  application: ApplicationEntity;
  modificationType: ModificationType;
}) => {
  const viewModel = ModifyFormViewModel.create(args);
  const [state, setState] = useState<ModifyFormGeneratorProps>(
    viewModel.getProps(),
  );
  useEffect(() => {
    setState(viewModel.getProps());
    // eslint-disable-next-line
  }, [setState, args.modificationType]);
  useEffect(() => {
    viewModel.setOnUpdated((props) => {
      setState(props);
    });
  }, [setState, viewModel]);

  return {
    ...state,
  };
};
